import { render, staticRenderFns } from "./ImagePlaceholder.vue?vue&type=template&id=79a7b4f8&scoped=true&"
import script from "./ImagePlaceholder.vue?vue&type=script&lang=js&"
export * from "./ImagePlaceholder.vue?vue&type=script&lang=js&"
import style0 from "./ImagePlaceholder.vue?vue&type=style&index=0&id=79a7b4f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a7b4f8",
  null
  
)

export default component.exports